import { Box, Button, IconButton, Switch, Tab, Tabs } from "@mui/material";
import { GridColDef } from "@mui/x-data-grid";
import Chip from "components/Chip";
import SearchBar from "components/SearchBar";
import TableComponent from "components/TableComponent";
import { Colors } from "constants/colors";
import MainContainer from "layout/MainContainer";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Listing } from "types/General";
import { isValidInput } from "utils/validations";

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const RoiDisbursement = () => {
  const navigate = useNavigate();
  const label = { inputProps: { "aria-label": "Switch demo" } };
  const [searchTerm, setSearchTerm] = useState<string>("");
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState<string>("");
  const [count, setCount] = useState(0);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState<number>(1);
  const [valueTabs, setValueTabs] = React.useState(0);

  const handleChangeTabs = (event: React.SyntheticEvent, newValue: number) => {
    setValueTabs(newValue);
  };

  const handlePageChange = (event: any, newPage: number) => {
    setPage(newPage + 1);
  };
  const columns: GridColDef[] = [
    {
      flex: 1,
      minWidth: 100,
      field: "name",
      headerName: "Investor",
      editable: false,
      sortable: false,

      renderCell: ({ row }) => {
        return (
          <div className="user_block">
            <p>John</p>
          </div>
        );
      },
    },
    {
      flex: 1,
      minWidth: 100,
      field: "plan",
      headerName: "Plan",
      editable: false,
      sortable: false,

      renderCell: ({ row }) => {
        return (
          <div className="user_block">
            <p>Gold Plan</p>
          </div>
        );
      },
    },
    {
      flex: 1,
      minWidth: 100,
      field: "amount",
      headerName: "Investment Amount",
      editable: false,
      sortable: false,

      renderCell: ({ row }) => {
        return (
          <div className="user_block">
            <p>$ 50,000</p>
          </div>
        );
      },
    },
    {
      flex: 1,
      minWidth: 100,
      field: "roi",
      headerName: "ROI%",
      editable: false,
      sortable: false,

      renderCell: ({ row }) => {
        return (
          <div className="user_block">
            <p>12%</p>
          </div>
        );
      },
    },
    {
      flex: 1,
      minWidth: 100,
      field: "monthlyRoi",
      headerName: "Monthly ROI",
      editable: false,
      sortable: false,

      renderCell: ({ row }) => {
        return (
          <div className="user_block">
            <p>$ 5000</p>
          </div>
        );
      },
    },
    {
      flex: 1,
      minWidth: 100,
      field: "nextPayout",
      headerName: "Next Payout",
      editable: false,
      sortable: false,

      renderCell: ({ row }) => {
        return (
          <div className="user_block">
            <p>20/9/2025</p>
          </div>
        );
      },
    },
    {
      flex: 1,
      minWidth: 100,
      field: "activeInvestors",
      headerName: "Active Investors",
      editable: false,
      sortable: false,

      renderCell: ({ row }) => {
        return (
          <div className="user_block">
            <p>12%</p>
          </div>
        );
      },
    },
    {
      flex: 1,
      minWidth: 150,
      field: "status",
      filterable: false,
      sortable: false,
      headerName: "Status",
      renderCell: ({ row }) => {
        return (
          <div className="user_block">
            <Chip
              backgroundColor={Colors.primary}
              color="white"
              label="Active"
            />
          </div>
        );
      },
    },

    {
      minWidth: 130,
      field: "action",
      headerName: "Action",
      editable: false,
      sortable: false,
      renderCell: () => (
        <div className="user_block">
          <Button variant="outlined" color="inherit" size="small">
            Process Now
          </Button>
        </div>
      ),
    },
  ];

  const dummyListings: Listing[] = [
    {
      _id: "1",
      title: "Honda Civic 2020",
      vehicleType: 1,
      coverImage: "/static/images/vehicle_side.jpg",

      soldStatus: 0,
      image: [],
      isBlocked: false,
      status: 0,
      isPremiumCar: false,
    },
    {
      _id: "2",
      title: "Yamaha R15 V3",
      vehicleType: 1,
      coverImage: "/static/images/vehicle_side.jpg",

      soldStatus: 0,
      image: [],
      isBlocked: false,
      status: 0,
      isPremiumCar: false,
    },
  ];

  return (
    <MainContainer>
      <div className="main_title">
        <h1>ROI Disbursement Management</h1>
        <p>
          <span onClick={() => navigate("/dashboard")}>Dashboard</span> - ROI
          Disbursement Management
        </p>
      </div>

      <div className="stats_boxes gap_m" style={{ marginBottom: "30px" }}>
        <div
          className="cards"
          style={{ paddingLeft: 20 }}
          // onClick={() => navigate("/dashboard/registered-users")}
        >
          <h2>$ 178,000</h2>
          <p>Monthly ROI Total</p>
        </div>

        <div
          className="cards"
          style={{ paddingLeft: 20 }}
          // onClick={() => navigate("/dashboard/registered-users")}
        >
          <h2>20</h2>
          <p>Active Investments</p>
        </div>

        <div
          className="cards"
          style={{ paddingLeft: 20 }}
          // onClick={() => navigate("/dashboard/registered-users")}
        >
          <h2>5</h2>
          <p>Successful Payouts</p>
        </div>
      </div>

      <div className="cards">
        <Box className="custom_tabs" sx={{ width: "100%" }}>
          <div className="table_header">
            <div className="left_s">
              <Box className="search_box">
                <SearchBar
                  searchTerm={searchTerm}
                  placeholder="Search"
                  setDebouncedSearchTerm={setDebouncedSearchTerm}
                  value={searchTerm}
                  onCross={() => setSearchTerm("")}
                  onChange={(val: any) => {
                    if (isValidInput(val.target.value)) {
                      setSearchTerm(val.target.value);
                    }
                  }}
                />
              </Box>
            </div>
            <div className="right_s">
              <Box>
                <Button className="btn btn_highlight">
                  <img src="/static/images/upload_icon.svg" alt="Icon" /> Export
                  CSV
                </Button>
              </Box>
            </div>
          </div>

          <Tabs
            value={valueTabs}
            onChange={handleChangeTabs}
            aria-label="basic tabs example"
            className="custom_tabs_links"
          >
            <Tab label="Active Investments" {...a11yProps(0)} />
            <Tab label="Payout History" {...a11yProps(1)} />
          </Tabs>

          <div className="sorting_table">
            <TableComponent
              columns={columns}
              rows={dummyListings}
              count={count}
              page={page}
              onPageChange={handlePageChange}
              loading={loading}
            />
          </div>
        </Box>
      </div>
    </MainContainer>
  );
};

export default RoiDisbursement;
